import type React from 'react';

import { observer } from 'mobx-react';

import AddControlButton from './controls/add-button';
import AddControlInput from './controls/input';
import { AddStoreProvider } from './stores/add-store';

export interface IProps {
  route: string;

  onAdd?: () => void;
  onBlur?: () => void;
}

const AddControl: React.FC<IProps> = observer(({ route, onAdd, onBlur }) => {
  return (
    <AddStoreProvider>
      <div className="add-control border-b-[1px] border-solid border-black">
        <AddControlInput route={route} onBlur={onBlur} />
        <span>&nbsp;</span>
        <AddControlButton route={route} onAdd={onAdd} />
      </div>
    </AddStoreProvider>
  );
});

AddControl.displayName = 'AddControl';

export default AddControl;
